export default __webpack_public_path__ + "static/DELL-7518b1f7c632351493d55500fff74691.svg";